const orderLists = (objectLists) => {
    return Object.values(objectLists.byId).sort((a, b) => {
        if (a.order > b.order)
            return 1;
        if (a.order < b.order)
            return -1;
        return 0;
    });
};

export { orderLists };
